import type { ComputedRef } from 'vue'
import type { AppBadgeColor } from '../../app-badge'
import type { BadgeSubscriptionStatusProps } from '../types/interfaces'

import { SubscriptionStatus } from '@brighterly/lib-core-types/subscription/enums'

import { useListsStore } from '@shared/model'

import { useBadgeFromStatus } from '../../app-badge'

interface BadgeSubscriptionStatusOptions {
  props: BadgeSubscriptionStatusProps
}

interface BadgeSubscriptionStatusReturn {
  color: ComputedRef<AppBadgeColor>
  text: ComputedRef<string>
}

const STATUS_COLORS: Record<SubscriptionStatus, AppBadgeColor> = {
  [SubscriptionStatus.Created]: 'blue',
  [SubscriptionStatus.Ongoing]: 'emerald',
  [SubscriptionStatus.Completed]: 'emerald',
  [SubscriptionStatus.Paused]: 'amber',
  [SubscriptionStatus.Failed]: 'red',
  [SubscriptionStatus.Retrying]: 'slate',
  [SubscriptionStatus.Canceled]: 'slate',
}

export const useBadgeSubscriptionStatus = ({ props }: BadgeSubscriptionStatusOptions): BadgeSubscriptionStatusReturn => {
  const listsStore = useListsStore()

  return useBadgeFromStatus<SubscriptionStatus>({
    status: () => props.status,
    colors: STATUS_COLORS,
    labels: () => listsStore.getLists?.subscription.status,
  })
}
